import { useState } from "react";
import { PERFECT_SCORE, WORST_SCORE } from "../../shared/domain.ts";
import { rowFor, share, shareText } from "../game/share.ts";
import type { DailyResult } from "../game/storage.ts";

export function DailySummary({
  result,
  streak,
  answers,
}: {
  result: DailyResult;
  streak: number;
  answers: { artist: string; title: string }[];
}) {
  const [copied, setCopied] = useState<"shared" | "copied" | "failed" | null>(null);

  return (
    <section className="summary">
      <h2 className="summary__score">
        {result.score}
        <span className="summary__of">/{WORST_SCORE}</span>
      </h2>
      <p className="summary__blurb">
        {result.score === PERFECT_SCORE
          ? "A perfect set. Nothing left to prove today."
          : `${result.verdicts.filter((v) => v.includes("exact")).length} of 5 solved`}
        {streak > 0 && ` · 🔥 ${streak} day streak`}
      </p>

      <ol className="summary__rows">
        {result.verdicts.map((verdicts, i) => (
          <li key={i} className="summary__row">
            <span className="summary__squares">{rowFor(verdicts)}</span>
            <span className="summary__answer">
              {answers[i] ? `${answers[i]!.artist} — ${answers[i]!.title}` : ""}
            </span>
          </li>
        ))}
      </ol>

      <button
        className="btn btn--primary"
        type="button"
        onClick={() => {
          void share(shareText(result, streak, window.location.origin)).then(setCopied);
        }}
      >
        {copied === "copied" ? "Copied!" : copied === "shared" ? "Shared!" : "Share result"}
      </button>
      {copied === "failed" && <p className="status">Couldn't copy — select and copy manually.</p>}

      <p className="summary__next">Come back tomorrow for a new set.</p>
    </section>
  );
}
